export default "__VITE_ASSET__CcSajH_1__"